<script>
import "@plugins/bootstrap-daterangepicker/daterangepicker.css"
import "@plugins/bootstrap-daterangepicker/daterangepicker.js"

export default {
	props: ['value','dateType'],
    mounted: function() {
        var option = {
            locale: {
              format: 'DD-MM-YYYY'
            },
            linkedCalendars: false,
            todayHighlight: false,
            autoclose: true,
            timePicker: false,
        }
        $(this.$el).daterangepicker(option).change((e)=>{
            this.$emit('input', e.target.value)
        });
        if(!this.value) this.$emit('input', "")
    },
    watch: {
        value: function (value) {
            $(this.$el).val(value)
        }
    }
}
</script>

<template>
	<input type="text" class="form-control" value="">
</template>

